import { gql } from '@apollo/client'

export type {
  Regions,
  // eslint-disable-next-line camelcase
  Regions_regions_Regions_results_Region as Region,
} from './types/index.graphql'

export const REGIONS = gql`
  query Regions {
    regions {
      results {
        id
        name
      }
    }
  }
`
